export default __webpack_public_path__ + "static/media/canada-flag.c3ad8cc8.svg";